import {Component, OnInit} from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WebinarService} from 'src/app/admin/admin-services/webinar.service';
import {first, take} from 'rxjs/operators';
import {AlertService} from 'src/app/services/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SchoolService} from 'src/app/services/school.service';
import { FileUploadComponent } from '../../../components/file-upload/file-upload.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf, NgClass, DatePipe } from '@angular/common';
import { NgxIntlTelInputModule } from '@justin-s/ngx-intl-tel-input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-webinar',
    templateUrl: './webinar.component.html',
    styleUrls: ['./webinar.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, NgFor, MatOptionModule, MatIconModule, NgIf, MatExpansionModule, NgClass, MatInputModule, MatChipsModule, FileUploadComponent, DatePipe]
})
export class WebinarComponent implements OnInit {

  // @TODO /!\
  // @TODO METTRE A JOUR LES FORMS & COE QUAND ON SAURA QUOI FAIRE DE LA PAGE !!
  // @TODO /!\

  // FILTRE
  public organisateurFormControl: UntypedFormControl = new UntypedFormControl();
  public hasQuestionFormControl: UntypedFormControl = new UntypedFormControl();
  public statusFormControl: UntypedFormControl = new UntypedFormControl();
  public orgaList: string[] = ['1', '2', '3', '4'];
  public tagList: string[] = ['livinfrance', 'premium', 'school'];
  public schoolList: any[] = [];

  //----------------------------------------------------------------------------------------------
  //
  // public editNameFC: FormControl = new FormControl(null, Validators.required);
  // public editDescFC: FormControl = new FormControl(null, Validators.required);
  // public editTagFC: FormControl = new FormControl(null, Validators.required);

  //
  public webinarList: any[] = [];
  public questionStatus: string = 'medium';

  // cover img
  public editCoverType: string = null;
  public defautCoverImage: string = 'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/school/process-background/webinar_bg.png';

  // fc
  public editFrTitle : UntypedFormControl = new UntypedFormControl(null, Validators.required);
  public editDescFC : UntypedFormControl = new UntypedFormControl(null, Validators.required);
  public editTagFC : UntypedFormControl = new UntypedFormControl(null, Validators.required);
  public schoolTagFC : UntypedFormControl = new UntypedFormControl(null, Validators.required);



  constructor(
    private webinarService: WebinarService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private schoolService: SchoolService,
  ) { }

  ngOnInit(): void {
    this.webinarService.getAllWebinars().pipe(first()).subscribe(data=> {
      data.forEach(d =>{
        d.datas = JSON.parse(d.datas);
      })
      data['isOpened'] = false;
      data['isEdited'] = false;
      this.webinarList = data;
    });

    this.schoolService.getAll().pipe(take(1)).subscribe((data: any) => {
      data = data.sort((a, b) => a.name > b.name ? 1 : a.name === b.name ? 0 : -1)
      this.schoolList = data;
    })

  }


  // @ TODO à venir
  public doFilter():void {
  }

  public saveEvent(webinar): void {
    if (this.editDescFC.valid && this.editFrTitle.valid && this.editTagFC.valid) {
      this.webinarService.updateInfos({
        id : webinar.id,
        title_fr: this.editFrTitle.value,
        description_fr: this.editDescFC.value,
        tag: this.editTagFC.value !== 'school' ? this.editTagFC.value : 'school',
        school_id: this.editTagFC.value == 'school' ? this.schoolTagFC.value : null,
      }).pipe(first()).subscribe(result => {
        if (result) {

          webinar.title_fr =  this.editFrTitle.value;
          webinar.description_fr =  this.editDescFC.value;
          webinar.tag =  this.editTagFC.value !== 'school' ? this.editTagFC.value : 'school';
          webinar.school_id = this.editTagFC.value == 'school' ? this.schoolTagFC.value : null;

          this.alertService.openSnackBar('Webinar mis à jour !', 'snack-success');
          this.clearEditingField();
          webinar.isOpened = false;
          webinar.isEdited = false;
        } else {
          this.alertService.openSnackBar('Une erreur est survenue.', 'snack-error');
        }
      })
    }
  }

  public switchQuestionBoxStatut(direction: string): void {
    if (direction == 'grow') {
      if (this.questionStatus == 'medium') {
        this.questionStatus = 'big';
      } else {
        this.questionStatus = 'medium';
      }
    } else {
      if (this.questionStatus == 'medium') {
        this.questionStatus = 'small';
      } else {
        this.questionStatus = 'medium';
      }
    }
  }

  public openBgEdit(modal): void {
    this.modalService.open(modal, {centered:true});
  }

  public goToLivestorm(type: string): void {
    if (type == 'homepage') {
      window.open('https://app.livestorm.co/#/login', '_blank')
    }
  }

  public editWebinar(webinar) :void {
    this.editFrTitle.setValue(webinar.title_fr);
    this.editDescFC.setValue(webinar.description_fr);
    this.editTagFC.setValue(webinar.tag);
    this.schoolTagFC.setValue(webinar.school_id);
  }

  public clearEditingField() : void {
    this.editFrTitle.setValue(null);
    this.editDescFC.setValue(null);
    this.editTagFC.setValue(null);
    this.schoolTagFC.setValue(null);
  }


}
